function product_price(id,price){
  
  var cookieCurrency = Currency.cookie.read();
  var shopCurrency = 'GBP';
  if(cookieCurrency != shopCurrency && cookieCurrency != null){ 
    var shopCurr = cookieCurrency;
  } 

  if(cookieCurrency == 'GBP' || cookieCurrency == null){
    var shopCurr = shopCurrency;
  }
  var currency='';
  if(price.indexOf("£")>= 0){
    price= price.replace("£","");
    var cur_sym = "£";
    var cur_code='gbp';
  }
  
  if(price.indexOf(",")>= 0){
    price= price.replace(",","");
   
  }
  
  if(price.indexOf("£")>= 0){
    price= price.replace("£","");
    var cur_sym = "£";
    var cur_code='gbp';
  }

  if(shopCurr != 'GBP'){

    var price = Currency.convert(price,'GBP', shopCurr);

    if(shopCurr=='EUR'){
      var cur_code='eur';
      var cur_sym='€';
    }
    if(shopCurr=='USD'){
      var cur_code='usd';
      var cur_sym='$';
    }

    var discount_value = $('#discount_value').val();
  
    var discount_price = price - (price*discount_value/100); 


    $(".discount_"+id).text(cur_sym+addCommas(Math.round(discount_price).toFixed(2)));
    $('.discount_'+id).attr("data-currency-"+cur_code,cur_sym+Math.round(discount_price).toFixed(2));


  }else{


    var discount_value = $('#discount_value').val();
  
    var discount_price = price - (price*discount_value/100); 


    $(".discount_"+id).text(cur_sym+addCommas(Math.round(discount_price).toFixed(2)));
    $('.discount_'+id).attr("data-currency-"+cur_code,cur_sym+Math.round(discount_price).toFixed(2));
    
  }
   
  
}